<template>
  <section class="data-company">
    <v-container grid-list-xl fluid>
      <v-layout wrap>
        <v-flex md2>
          <v-text-field
            v-model="company.registration_number"
            label="Matrícula"
            required
            :disabled="true"
          />
        </v-flex>

        <v-flex md4>
          <v-combobox
            v-model="company.role.description"
            :items="role"
            label="Cargo"
            :disabled="true"
          />
        </v-flex>

        <v-flex md4>
          <v-combobox
            v-model="company.administrative_unit.name"
            :items="sector"
            label="Setor"
            :disabled="true"
          />
        </v-flex>

        <v-flex md3>
          <v-combobox
            v-model="company.workday"
            :items="workload"
            label="Carga horária"
            :disabled="true"
          />
        </v-flex>

        <v-flex md3>
          <v-menu
            ref="menu"
            :close-on-content-click="false"
            v-model="menu"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px">

            <v-date-picker
              ref="picker"
              v-model="date"
              :max="new Date().toISOString().substr(0, 10)"
              @change="save" />
          </v-menu>

          <v-text-field
              slot="activator"
              v-model="company.admission_date"
              label="Data de admissão"
              prepend-icon="event"
              :disabled="true"
            />
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'DataCompany',
  data() {
    return {
      date: null,
      menu: false,
      role: [
        'Desenvolvedor',
        'Gerente',
      ],
      sector: [
        'Financeiro',
        'Gerente',
        'Presidência',
      ],
      workload: [
        '20 horas semanais',
        '30 horas semanais',
        '40 horas semanais',
      ],
    };
  },
  watch: {
    menu(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.picker.activePicker = 'YEAR';
        });
      }
    },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
    },
  },
  computed: {
    company() {
      return this.$store.getters.user;
    },
  },
};
</script>

<style scoped lang="scss">
// .data-company {}
</style>



// WEBPACK FOOTER //
// src/components/account/profile/DataCompany.vue